import React, { useState } from "react";
import { FormularioManual2023 } from './FormularioManual2023';
import { TablaMovimientosManuales2023 } from './TablaMovimientosManuales2023';
import { BotonesAcciones2023 } from './BotonesAcciones2023';

export const MovimientosManuales2023 = () => {

    const [movimiento, setMovimiento] = useState({
        tcTrabajador: {},
        registroPatronal: "* Elije un registro patronal"
    });
    
    const [movimientosCapturados, setMovimientosCapturados] = useState([]);
    const [movimientosSeleccionados,setMovimientosSeleccionados]=useState([]);    
    
    return (
        <div>
            <FormularioManual2023 movimiento={movimiento} setMovimiento={setMovimiento}
                setMovimientosCapturados={setMovimientosCapturados} 
                setMovimientosSeleccionados={setMovimientosSeleccionados}/>

            <TablaMovimientosManuales2023 movimientosCapturados={movimientosCapturados}
                movimientosSeleccionados={movimientosSeleccionados} 
                setMovimientosSeleccionados={setMovimientosSeleccionados}/>

             <BotonesAcciones2023 movimientosSeleccionados={movimientosSeleccionados} 
             setMovimientosSeleccionados={setMovimientosSeleccionados}
             setMovimiento={setMovimiento} movimientosCapturados={movimientosCapturados} 
             setMovimientosCapturados={setMovimientosCapturados}/>   
        </div>
    );
}